export const danmakuList = [
  '这波操作我给满分',
  '笑不活了哈哈哈哈',
  '弹幕比我本人还懂我',
  '前面的等等我',
  '同一个世界同一种生活',
  '这段我要循环了',
  '建议直接进教材',
  '这就是名场面本面',
  '我已截图保存',
  '评论区集合',
  '接梗接得太丝滑了',
  '这届网友真的很有才',
  '我笑了整整三分钟',
  '好家伙，直接封神',
  '此处应有掌声',
  '高能预警已失效',
  '第一次看弹幕比正片精彩',
  '给我整不会了',
  '这波节奏彻底失控',
  '默默点了个赞',
  '玩梗我是认真的',
  '一整个被逗到',
  '这个梗我能用一年',
  '来晚了，但赶上了热闹',
];

export const danmakuRows = [
  [
    '这波操作我给满分',
    '笑不活了哈哈哈哈',
    '弹幕比我本人还懂我',
    '前面的等等我',
    '同一个世界同一种生活',
    '这段我要循环了',
  ],
  [
    '建议直接进教材',
    '这就是名场面本面',
    '我已截图保存',
    '评论区集合',
    '接梗接得太丝滑了',
    '这届网友真的很有才',
  ],
  [
    '我笑了整整三分钟',
    '好家伙，直接封神',
    '此处应有掌声',
    '高能预警已失效',
    '第一次看弹幕比正片精彩',
    '给我整不会了',
  ],
];